"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBorderStyles = exports.borderedVerticalOff = exports.borderedVertical = exports.borderedTopOff = exports.borderedTop = exports.borderedStartOff = exports.borderedStart = exports.borderedOff = exports.borderedHorizontalOff = exports.borderedHorizontal = exports.borderedEndOff = exports.borderedEnd = exports.borderedBottomOff = exports.borderedBottom = exports.bordered = void 0;
require("./border.css");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
const bordered = "cds-bordered-b17mbjy1";
exports.bordered = bordered;
const borderedOff = "cds-borderedOff-b1t6c2r7";
exports.borderedOff = borderedOff;
const borderedStart = "cds-borderedStart-b1v2nwoe";
exports.borderedStart = borderedStart;
const borderedStartOff = "cds-borderedStartOff-b8xo8xy";
exports.borderedStartOff = borderedStartOff;
const borderedEnd = "cds-borderedEnd-b1s4rn7i";
exports.borderedEnd = borderedEnd;
const borderedEndOff = "cds-borderedEndOff-b13xych6";
exports.borderedEndOff = borderedEndOff;
const borderedTop = "cds-borderedTop-b1fsiv3z";
exports.borderedTop = borderedTop;
const borderedTopOff = "cds-borderedTopOff-b19a1ll";
exports.borderedTopOff = borderedTopOff;
const borderedBottom = "cds-borderedBottom-bfptfuw";
exports.borderedBottom = borderedBottom;
const borderedBottomOff = "cds-borderedBottomOff-b13rxjje";
exports.borderedBottomOff = borderedBottomOff;
const borderedHorizontal = [borderedStart, borderedEnd].join(' ');
exports.borderedHorizontal = borderedHorizontal;
const borderedVertical = [borderedTop, borderedBottom].join(' ');
exports.borderedVertical = borderedVertical;
const borderedHorizontalOff = [borderedStartOff, borderedEndOff].join(' ');
exports.borderedHorizontalOff = borderedHorizontalOff;
const borderedVerticalOff = [borderedTopOff, borderedBottomOff].join(' ');
exports.borderedVerticalOff = borderedVerticalOff;
const getBorderStyles = props => {
  const args = [];

  // When elevating, always apply a border
  if (props.elevation) {
    return bordered;
  }
  if (props.bordered !== undefined) {
    args.push(props.bordered ? bordered : borderedOff);
  }
  if (props.borderedTop !== undefined) {
    args.push(props.borderedTop ? borderedTop : borderedTopOff);
  }
  if (props.borderedBottom !== undefined) {
    args.push(props.borderedBottom ? borderedBottom : borderedBottomOff);
  }
  if (props.borderedStart !== undefined) {
    args.push(props.borderedStart ? borderedStart : borderedStartOff);
  }
  if (props.borderedEnd !== undefined) {
    args.push(props.borderedEnd ? borderedEnd : borderedEndOff);
  }
  if (props.borderedHorizontal !== undefined) {
    args.push(props.borderedHorizontal ? borderedHorizontal : borderedHorizontalOff);
  }
  if (props.borderedVertical !== undefined) {
    args.push(props.borderedVertical ? borderedVertical : borderedVerticalOff);
  }
  return (0, _linaria.cx)(...args);
};
exports.getBorderStyles = getBorderStyles;